<script>
export default {
  name: "MUIList",

  props: {
    /**
     * Defines the rendered list type.
     *
     * @values ul, ol
     */
    listType: {
      type: String,
      default: 'ul',
      validator: (value) => ['ul', 'ol'].includes(value)
    },

    /**
     * The list orientation.
     *
     * @values row, column, row-nowrap
     */
    orientation: {
      type: String,
      default: 'row',
      validator: (value) => ['row', 'column', 'row-nowrap'].includes(value)
    },

    /**
     * The alignment based in the cross axis applied to the list items.
     *
     * @values start, center, end, stretch
     */
    align: {
      type: String,
      default: 'start',
      validator: (value) => ['start', 'center', 'end', 'stretch'].includes(value)
    },

    /**
     * The alignment based in the main axis applied to the list items.
     *
     * @values start, center, end, space-between, space-around, space-evenly
     */
    justify: {
      type: String,
      default: 'start',
      validator: (value) => ['start', 'center', 'end', 'space-between', 'space-around', 'space-evenly'].includes(value)
    },

    /**
     * Applies the list gap.
     *
     * The accepted values are related
     * to those ones defined in "utilityClasses.styl" file.
     *
     * @values 1, 2, 4, 8
     */
    gap: {
      type: Number,
      default: 4,
      validator: (value) => [1, 2, 4, 8].includes(value)
    },

    /**
     * Defines whether the list-items should expand or not.
     */
    fluidItems: {
      type: Boolean,
      default: false
    },

    /**
     * Applies a striped effect to the list.
     */
    striped: Boolean
  },

  computed: {
    /**
     * Gets the list classes.
     *
     * @returns {array} An array of classes.
     */
    getListClasses() {
      return [
        'mui-list',
        `mui-list--${this.orientation}`,
        `mui-list--justify-${this.justify}`,
        `mui-list--align-${this.align}`,
        `gap-${this.gap}`,
        {
          'mui-list--striped': this.striped
        }
      ];
    },

    /**
     * Gets the list-item classes.
     *
     * @returns {array} An array of classes.
     */
    getListItemClasses() {
      return [
        'mui-list__item',
        {
          'mui-list__item--fluid': this.fluidItems
        }
      ];
    }
  },

  /**
   * Render the component.
   *
   * @returns {HTMLElement}
   */
  render(h) {
    /**
     * @slot Default
     */
    const slots = this.$slots.default;

    if (!slots) {
      return;
    }

    const elements = [];

    slots.forEach(slot => {
      if (slot.tag) {
        elements.push(slot);
      }
    });

    return h(
      this.listType,
      {class: this.getListClasses},
      elements.map(element => h('li', {class: this.getListItemClasses}, [element]))
    );
  }
}
</script>
